//Models
PJQ.models.userTypes = {};
PJQ.models.userTypes.UserType = PJQ.models.BaseModel.extend({
	idAttribute: 'userTypeId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'userTypes',
				value: this.id < 0 ? -this.id : this.id
			}
		])
	},
	fetchSystemPermissions: function (callback) {
		let perm = new PJQ.models.permissions.SystemPermissions({
			userTypeId: this.id
		});
		if (this.id > 0) {
			perm.fetch({
				success: _.bind(function () {
					callback(perm);
				}, this)
			});
		}
		else {
			callback(perm);
		}
	},
	fetchProjectPermissions: function (callback) {
		let perm = new PJQ.models.permissions.ProjectPermissions({
			userTypeId: this.id
		});
		if (this.id > 0) {
			perm.fetch({
				success: _.bind(function () {
					callback(perm);
				}, this)
			});
		}
		else {
			callback(perm);
		}
	},
	fetchSystemNotificationSettings: function (callback) {
		let notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
			userTypeId: this.id
		});
		if (this.id > 0) {
			notificationSettings.fetch({
				success: _.bind(function () {
					callback(notificationSettings);
				}, this)
			});
		}
		else {
			callback(notificationSettings);
		}
	},
	fetchProjectNotificationSettings: function (callback) {
		let notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
			userTypeId: this.get('userTypeId')
		});
		if (this.id > 0) {
			notificationSettings.fetch({
				success: _.bind(function () {
					callback(notificationSettings);
				}, this)
			});
		}
		else {
			callback(notificationSettings);
		}
	},
});


//Collections
PJQ.collections.userTypes = {};
PJQ.collections.userTypes.UserTypes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userTypes.UserType,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'userTypes'
			}
		])
	},
	getDefault: function (isCompanyUser = false) {
		return _.find(this.models, function (model) {
			return isCompanyUser === model.get('isCompanyUser') && model.get('isDefault');
		});
	},
	getById: function (id) {
		return _.find(this.models, function (model) {
			return model.id == id;
		});
	},
	getByIsCompany: function (isCompany) {
		if (isCompany == null) {
			return this.models;
		}

		return _.filter(this.models, function (userType) {
			return isCompany === userType.get('isCompanyUser');
		})
	},
	copy: function (callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes'
				},
				{
					endpoint: 'copy'
				}
			])
		}).post().done(_.bind(function (userTypes) {
			this.reset(userTypes);
			callback();
		}, this));
	}
});
